import { useState, useEffect, useCallback } from 'preact/hooks';
import { useScreenSize, SCREEN_SIZES } from 'react-hooks/useScreenSize';
import { Button, BUTTON_SCHEMES } from './Button';
import { StarterKitModalComponent } from './StarterKitModalComponent';

const ImageComponent = ({ src, alt, className }) => (
  <img src={src} className={className} alt={alt} />
);

const WaterAsset = ({ src, className }) => (
  <div className={className}>
    <img src={src} className="tw-size-full tw-max-w-[1200px] tw-object-contain" alt="" />
  </div>
);

export const FeaturedProductSection = ({ section }) => {
  const { screenSize } = useScreenSize();
  const isMobile = screenSize === SCREEN_SIZES.MOBILE;
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = useCallback(() => setIsModalOpen(true), []);
  const handleCloseModal = useCallback(() => setIsModalOpen(false), []);

  useEffect(() => {
    const checkHash = () => {
      if (window.location.hash === '#adamssuperstarterkit') {
        setIsModalOpen(true);
      }
    };

    checkHash(); // Run once when component mounts

    window.addEventListener('hashchange', checkHash);
    return () => window.removeEventListener('hashchange', checkHash);
  }, []);

  const renderImages = () => {
    if (isMobile) {
      return (
        <>
          <div className='tw-absolute tw-left-0 tw-top-0 tw-w-full tw-items-center tw-justify-center'>
            <ImageComponent src={section.featured_product_image_mobile} className="tw-size-full tw-max-w-[1200px] tw-object-cover tw-object-center" alt="Featured Product" />
          </div>
          <WaterAsset src={section.left_water_mobile} className="tw-absolute tw-inset-0 tw-z-[2] tw-flex tw-items-center tw-justify-center" />
          <WaterAsset src={section.right_water_mobile} className="tw-absolute tw-inset-0 tw-z-[2] tw-flex tw-items-center tw-justify-center" />
        </>
      );
    } 
      return (
        <>
          <div className='tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center'>
            <ImageComponent src={section.featured_product_image} className="tw-size-full tw-max-h-[600px] tw-min-h-[300px] tw-max-w-[1200px] tw-object-cover tw-object-left" alt="Featured Product" />
          </div>
          <WaterAsset src={section.top_water} className="tw-absolute tw-left-0 tw-top-0 tw-z-[2] tw-flex tw-w-full tw-items-start tw-justify-center" />
          <WaterAsset src={section.left_water} className="tw-absolute tw-inset-0 tw-z-[2] tw-flex tw-items-center tw-justify-center" />
          <WaterAsset src={section.right_water} className="tw-absolute tw-inset-0 tw-z-[2] tw-flex tw-items-center tw-justify-center" />
        </>
      );
    
  };

  return (
    <div {...section.section_data_att} className="tw-relative tw-mx-auto tw-min-h-[348px] tw-w-full tw-max-w-screen-desktop tw-pb-48 tablet:tw-pb-64">
      <div className="tw-relative tw-h-auto tw-w-full tw-overflow-hidden tw-rounded-8">
        <ImageComponent src={isMobile ? section.bg_image_mobile : section.bg_image} className="tw-h-auto tw-min-h-[300px] tw-w-full tw-object-cover" alt="Background" />
        {renderImages()}
        <div className={`tw-absolute tw-z-[2] tw-w-full ${isMobile ? 'tw-bottom-0 tw-left-0 tw-flex tw-h-1/2 tw-justify-center tw-px-[44px] tw-pb-12' : 'tw-inset-0 tw-flex tw-items-center tw-justify-end tw-px-16'}`}>
          <div className={`tw-flex tw-flex-col tw-text-white ${isMobile ? 'tw-w-full tw-items-center tw-justify-end tw-text-center' : 'tw-w-1/2 tw-max-w-[600px] tw-items-center tw-pr-32'}`}>
            {section.headline_image && <ImageComponent src={section.headline_image} className="tw-mb-4" alt="Headline" />}
            {!isMobile && (
              <p className="cirk-heading-h5 tw-pt-16 tw-text-center tw-font-bold tw-uppercase">
                Sip like a star with hydration that's worth the hype.
              </p>
            )}
            <Button
              scheme={BUTTON_SCHEMES.WHITE}
              onClick={handleOpenModal}
              fullWidth={true}
              dataUxTrackClick="Home Page - Adam's Starter Kit - Shop Now"
              classNames="tw-w-full tablet:tw-w-[210px] tw-mt-16"
            >
              Shop Now
            </Button>
          </div>
        </div>
      </div>
      <StarterKitModalComponent
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        product={section.featured_product}
      />
    </div>
  );
};